module.exports = __webpack_public_path__ + "media/images/regions_old/Maradi-cf439b587cd74904e864422e1253f782.png";